import { render } from "./PollutionDemo.vue?vue&type=template&id=32a24b39&scoped=true"
import script from "./PollutionDemo.vue?vue&type=script&lang=js"
export * from "./PollutionDemo.vue?vue&type=script&lang=js"

import "./PollutionDemo.vue?vue&type=style&index=0&id=32a24b39&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a24b39"]])

export default __exports__